module.exports = __webpack_public_path__ + "static/pic13-96cc8e42b4d48b14b2f149312ec32872.jpg";